import React from "react";
import BreakdownTable from "../../../../../../components/BreakdownTable";

function UpcomingRequestTable({
  object,
  params,
  selectedIds,
  onSelectAll,
  onSelectOne,
  onChange,
  onChange2,
  onAdd,
  onDelete,
  disableAdd,
  hasQuantity,
  showUOM,
  disableQty,
  checkbox,
  showQuantityApprove,
  disableQtyApprove,
  hasRemarks,
  getObjectId,
  showAddButton,
}) {
  console.log("Objects", object);
  return (
    <>
      {!["For Reconciliation", "Pending Partially Received"].includes(
        object?.status,
      ) && (
        <BreakdownTable
          title={
            object?.status === "Pending"
              ? "Items"
              : object?.status === "Approved"
                ? "Requested Items"
                : "Requested Items"
          }
          data={object.items || object.raw_materials}
          selectedIds={selectedIds}
          onSelectAll={onSelectAll}
          onSelectOne={onSelectOne}
          onChange={onChange}
          onChange2={onChange2}
          onAdd={onAdd}
          onDelete={onDelete}
          disableAdd={true}
          hasQuantity={false}
          showUOM={false}
          disableQty={true}
          checkbox={object?.id ? false : true}
          showQuantityApprove={params?.approve ? true : false}
          disableQtyApprove={false}
        />
      )}
      {[
        "Approved",
        "Completed",
        "Pending Fully Received",
        "Dispatched",
        "Partially Received",
        "For Reconciliation",
      ].includes(object?.status) && (
        <BreakdownTable
          title="Approved Items"
          data={
            object.raw_materials ||
            (object.items || []).map((item) => ({
              ...item,
              quantity: item.quantityApprove || item.quantity, // override for display
            }))
          }
          selectedIds={selectedIds}
          onSelectAll={onSelectAll}
          onSelectOne={onSelectOne}
          onChange={onChange}
          onAdd={onAdd}
          onDelete={onDelete}
          disableAdd={!hasRemarks && !getObjectId}
          hasQuantity={hasRemarks || !!getObjectId}
          showUOM={false}
          disableQty={true}
          checkbox={object?.id ? false : true}
          showAddButton={false}
        />
      )}
      {["Partially Received"].includes(object?.status) && (
        <BreakdownTable
          title="Remaining Items for Delivery"
          data={
            object.raw_materials ||
            (object.items || []).map((item) => ({
              ...item,
              quantity:
                item.quantityApprove - item.quantityReceive || item.quantity, // override for display
            }))
          }
          selectedIds={selectedIds}
          onSelectAll={onSelectAll}
          onSelectOne={onSelectOne}
          onChange={onChange}
          onAdd={onAdd}
          onDelete={onDelete}
          disableAdd={!hasRemarks && !getObjectId}
          hasQuantity={hasRemarks || !!getObjectId}
          showUOM={false}
          disableQty={true}
          checkbox={object?.id ? false : true}
          showAddButton={false}
        />
      )}
      {["Pending Partially Received", "For Reconciliation"].includes(
        object?.status,
      ) && (
        <BreakdownTable
          title="Received Items for Delivery"
          data={
            object.raw_materials ||
            (object.items || []).map((item) => ({
              ...item,
              quantity: item.quantityReceive, // override for display
            }))
          }
          selectedIds={selectedIds}
          onSelectAll={onSelectAll}
          onSelectOne={onSelectOne}
          onChange={onChange}
          onAdd={onAdd}
          onDelete={onDelete}
          disableAdd={!hasRemarks && !getObjectId}
          hasQuantity={hasRemarks || !!getObjectId}
          showUOM={false}
          disableQty={true}
          checkbox={object?.id ? false : true}
          showAddButton={false}
        />
      )}
    </>
  );
}

export default UpcomingRequestTable;

// <UpcomingRequestTable
//                 object={object}
//                 params={params}
//                 selectedIds={this.state.selectedRawIds}
//                 onSelectAll={this.handleSelectAll}
//                 onSelectOne={this.handleSelectOne}
//                 onChange={this.handleChangeQuantity}
//                 onChange2={this.handleChangeQuantity2}
//                 onAdd={() => this.handleOpenRaw()}
//                 onDelete={() => this.handleDeleteSelected()}
//                 disableAdd={true}
//                 hasQuantity={false}
//                 showUOM={false}
//                 disableQty={true}
//                 checkbox={object?.id ? false : true}
//                 showQuantityApprove={params?.approve ? true : false}
//                 disableQtyApprove={false}
//                 hasRemarks={this.state.hasRemarks}
//                 getObjectId={this.getObjectId()}
//                 showAddButton={false}
//               />
//               <BreakdownTable
//                 title={
//                   object?.status === "Pending"
//                     ? "Items"
//                     : object?.status === "Approved"
//                       ? "Requested Items"
//                       : "Requested Items"
//                 }
//                 data={object.items || object.raw_materials}
//                 selectedIds={this.state.selectedRawIds}
//                 onSelectAll={this.handleSelectAll}
//                 onSelectOne={this.handleSelectOne}
//                 onChange={this.handleChangeQuantity}
//                 onChange2={this.handleChangeQuantity2}
//                 onAdd={() => this.handleOpenRaw()}
//                 onDelete={() => this.handleDeleteSelected()}
//                 disableAdd={true}
//                 hasQuantity={false}
//                 showUOM={false}
//                 disableQty={true}
//                 checkbox={object?.id ? false : true}
//                 showQuantityApprove={params?.approve ? true : false}
//                 disableQtyApprove={false}
//               />
//               {[
//                 "Approved",
//                 "Completed",
//                 "Pending Fully Received",
//                 "Dispatched",
//                 "Partially Received",
//                 "For Reconciliation",
//               ].includes(object?.status) && (
//                 <BreakdownTable
//                   title="Approved Items"
//                   data={
//                     object.raw_materials ||
//                     (object.items || []).map((item) => ({
//                       ...item,
//                       quantity: item.quantityApprove || item.quantity, // override for display
//                     }))
//                   }
//                   selectedIds={this.state.selectedRawIds}
//                   onSelectAll={this.handleSelectAll}
//                   onSelectOne={this.handleSelectOne}
//                   onChange={this.handleChangeQuantity}
//                   onAdd={() => this.handleOpenRaw()}
//                   onDelete={() => this.handleDeleteSelected()}
//                   disableAdd={!this.state.hasRemarks && !this.getObjectId()}
//                   hasQuantity={
//                     this.state.hasRemarks || !!this.getObjectId()
//                   }
//                   showUOM={false}
//                   disableQty={true}
//                   checkbox={object?.id ? false : true}
//                   showAddButton={false}
//                 />
//               )}

//               {["Partially Received"].includes(object?.status) && (
//                 <BreakdownTable
//                   title="Remaining Items for Delivery"
//                   data={
//                     object.raw_materials ||
//                     (object.items || []).map((item) => ({
//                       ...item,
//                       quantity:
//                         item.quantityApprove - item.quantityReceive ||
//                         item.quantity, // override for display
//                     }))
//                   }
//                   selectedIds={this.state.selectedRawIds}
//                   onSelectAll={this.handleSelectAll}
//                   onSelectOne={this.handleSelectOne}
//                   onChange={this.handleChangeQuantity}
//                   onAdd={() => this.handleOpenRaw()}
//                   onDelete={() => this.handleDeleteSelected()}
//                   disableAdd={!this.state.hasRemarks && !this.getObjectId()}
//                   hasQuantity={
//                     this.state.hasRemarks || !!this.getObjectId()
//                   }
//                   showUOM={false}
//                   disableQty={true}
//                   checkbox={object?.id ? false : true}
//                   showAddButton={false}
//                 />
//               )}
